// eslint-disable-next-line
import React, { useState, useEffect } from "react";
// eslint-disable-next-line
import { Link, Route, Routes, useParams } from "react-router-dom";
// eslint-disable-next-line
import { auth, firebase } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import {
  admin,
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  onAuthStateChanged,
  deleteUser,
} from "@firebase/auth";
// eslint-disable-next-line
import NavBar from "./Navbar";

import "./Messages.css";

function App() {
  // eslint-disable-line no-unused-vars

  const { only2studentid, studentid, classid, language, role} = useParams();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [donotshow, setDonotshow] = useState();
  const [someoneisloggedin, setSomeoneisloggedin] = useState(false);
  const [id, setId] = useState();

  const [school, setSchool] = useState();

  const auth = getAuth();

  const Adminmainmenu = "role/" + role + "/mainmenupage/id/" + id;

  // onAuthStateChanged(auth, (user) => {

  //   if (user) {
  //     setSomeoneisloggedin(true);
  //     if (user.email === username) {
  //       alert("active email", user.email);
  //       const uid = user.uid;
  //       setId(uid)
  //     }

  //   } else {
  //     setSomeoneisloggedin(false);
  //     setId("");
  //     setRole("");
  //   }
  // });

  const cardData = ["hello", "goodbye", "hii"];
  async function signout() {
    auth.signOut();
    setId();
  }

  async function signin() {
    signInWithEmailAndPassword(auth, username, password)
      .then((userCredential) => {
        let user2 = JSON.stringify(userCredential.user);
        let user = userCredential.user.email;
        let idd = userCredential.user.uid;
        console.log(user + username);

        setSomeoneisloggedin(true);
        if (user == username) {
          seeifpersonexists(idd);

          setId(idd);

          console.log(user);
          console.log(idd);
        }
      })
      .catch((error) => {
        const errorMessage = error.message;
        console.log(errorMessage);
      })
      .then(() => {
        setUsername("");
        setPassword("");
        console.log("You are signed in2");
      });
  }

  useEffect(() => {
    setDonotshow(true);
  }, []);

  const onChanged1 = (text) => {
    setUsername(text);
  };

  const onChanged2 = (text) => {
    setPassword(text);
  };

  async function seeifpersonexists(iddd) {
    const docRef2 = doc(firebase, "users", iddd);

    const docData = await getDoc(docRef2)
      .then(async (userRec) => {
        let object2 = userRec.data();
        console.log(object2.role);
   
        setSchool()
      })
      .catch((error) => {
        // Handle any errors that occur
      })
      .then(async () => {
        console.log("ending rightnow");
      });
  }

  return (
    <div className="App22">
      <NavBar donotshow={donotshow} role={role}/>
      <div className="App29">
        <header className="App-header">
          <div className="container2">
            <div className="section591">
              <p className="section5922ab29">Search By Date</p>

              <br />
              <br />

              {/* <p className="section5922abcx">Please delete the rest by pressing ⌫.</p>

            <ul>
              {cardData.map((info, i) => (
                <li key={i} className="list" >{info} <div className="section5922aaa" onClick={() => deletethisnumber(info)}>⌫
                </div>
                </li>
              ))}

              {cardData.map((info, i) => (
                <li key={i} className="list" >{info} <div className="section5922aaa" onClick={() => deletethisemail(info)}>⌫
                </div>
                </li>
              ))}
            </ul>
            <p className="section5922ax">Add any additional phone number or email address if it is there where you would also like to receive messages.</p> */}
            </div>
          </div>
          <div className="field22">
            <input
              placeholder="Username"
              placeholdertextcolor="#BEBEBE"
              value={username} // ...force the input's value to match the state variable...
              onChange={(e) => onChanged1(e.target.value)}
              type="text"
            />
          </div>

          <div className="field22">
            <input
              placeholder="Password"
              placeholdertextcolor="#BEBEBE"
              value={password} // ...force the input's value to match the state variable...
              onChange={(e) => onChanged2(e.target.value)}
              type="text"
            />
          </div>
          <div className="section598">
            {typeof username != "undefined" &&
            username.length > 0 &&
            typeof password != "undefined" &&
            password.length > 0 ? (
              <p className="section5922ax2" onClick={() => signin()}>
                Enter
              </p>
            ) :  typeof id != "undefined" ? (
              <p className="section5922ax2" onClick={() => signout()}>
              Sign Out
            </p>
            ) : (
              <p className="section5922ax2blackey"> Enter2 </p>
            )}

           
          </div>
        </header>
      </div>
    </div>
  );
}

export default App;
